import React, { Fragment } from 'react';

import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { IconButton, Box } from '@material-ui/core';

import projectLogo from '../../assets/images/flowtrace_logo_only.svg';

const HeaderLogo = () => {
  return (
    <Fragment>
      <div className={clsx('app-header-logo', {})}>
        <Box
          className="header-logo-wrapper"
          title="Flowtrace">
          <Link to="/Dashboard" className="header-logo-wrapper-link">
            <IconButton
              color="primary"
              size="medium"
              className="header-logo-wrapper-btn">
              <img
                className="app-header-logo-img"
                alt="Flowtrace"
                src={projectLogo}
              />
            </IconButton>
          </Link>
          <Box className="header-logo-text">Flowtrace</Box>
        </Box>
      </div>
    </Fragment>
  );
};

export default HeaderLogo;
